




















































































































































import { CatalogueItemModel } from '@/libs/Api';
import { catalogueItemsStore } from '@/libs/catalogue-items/+state/store';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import Page from '@/Page.vue';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';

import CatalogItemDialog from '@/libs/settings/components/CatalogItemDialog.vue';
import ExportDialog from '@/libs/common/components-smart/ExportDialog.vue';
import DeleteDialog from '@/libs/common/components/DeleteDialog.vue';
import { CrudQueryPredicate } from '@/libs/core/+state/models/crud-query-predicate';

@Component({
    components: {
        CatalogItemDialog
    }
})
export default class Catalog extends Page {

    filterActive = true;
    catalogItemTypeFilter: string | null = "";
    catalogueItem: CatalogueItemModel | null = null;
    searchValue: string | null = null;
    mobileFiltersShow = false;

    @Prop() tenantId!: string;

    tableHeaders = [
        { text: "Název úkonu", value: "name", align: "left" },
        { text: "Typ úkonu", value: "catalogueItemType", align: "left" },
        { text: "Stav", value: "isActive", align: "left" },
        { text: "", value: "id", align: "right" }
    ];

    get loading(): boolean {
        return catalogueItemsStore.useGetter(CrudGetter.Pending);
    }

    get items(): CatalogueItemModel[] {
        return [...catalogueItemsStore.useGetter(CrudGetter.Data)];
    }

    get exporting(): boolean {
        return catalogueItemsStore.useGetter(CrudGetter.Downloading);
    }

    @Ref() dialog!: CatalogItemDialog;
    @Ref() exportDialog!: ExportDialog;
    
    @Watch("searchValue")
    @Watch("filterActive")
    @Watch("catalogItemTypeFilter")
    filtersChanged() {
        this.loadItems();
    }

    mounted () {
        this.loadItems();
    }

    getFilters() {
        let filters: CrudQueryPredicate[] = [
            { field: "isActive", op: "eq", comparand: this.filterActive }
        ];
        if (this.catalogItemTypeFilter)
            filters.push({
                field: "billingType",
                op: "eq",
                comparand: this.catalogItemTypeFilter
            });
        if (this.searchValue)
            filters.push({
                field: "name",
                op: "c",
                comparand: this.searchValue
            });
        return filters;
    }

    loadItems () {
        catalogueItemsStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<CatalogueItemModel>([
            { field: "name", index: 1, order: "asc" }
        ], this.getFilters()));
    }

    createItemClick () {
        this.dialog.open();
    }

    openItemClick (v: CatalogueItemModel) {
        this.dialog.open(v.id);
    }

    getPriceSuffix(item: CatalogueItemModel) {
        return item == null || item.unitOfMeasure == null ? "" : (" Kč / " + this.$i18n.t("codebooks.".concat(item.unitOfMeasure.shortNameIdentifier!)));
    }

    exportClick () {
        this.exportDialog.open();
    }

    exportDownload () {
        const filters = this.getFilters();
        catalogueItemsStore.dispatch(CrudAction.Download, createCrudQueryPayload<CatalogueItemModel>([
            { field: "name", index: 1, order: "asc" }
        ], filters));
        this.subscribe(catalogueItemsStore, CrudReponse.Download).then(() => {
            this.exportDialog.close();
        });
    }

}
